import { ActionTypes } from "../constants/action-types";

const initialState = {
  processlistdata: [],
};

export const ProcessListReducer = (state = initialState, action) => {
  switch (action.type) {

    case ActionTypes.FETCH_PROCESS_LIST_SUCCESS:
      return {
        ...state,
        processlistdata: action.payload,
        
        
      };
  
    default:
      return state;
  }
};
